
        import '/home/builduser/work/c1dd1064fea009a6/santa-editor/packages/rEditor/rootComps/helpHome/blocks/block.scss.css.virtualfile';
        module.exports = {"block":"_block_l1grl_7","blockTitle":"_blockTitle_l1grl_15","blockTitleLabel":"_blockTitleLabel_l1grl_19"};